module.exports = __webpack_public_path__ + "img/art-41.c7581c12.png";